import { useEffect, useState } from 'react';
import React from 'react';

import { AuthAlert } from '../../components/auth/AuthAlert';
import { AuthButton } from '../../components/auth/AuthButton';
import { AuthFooterLink } from '../../components/auth/AuthFooterLink';
import { AuthInput } from '../../components/auth/AuthInput';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { useAppDispatch } from '../../hooks';
import { userReducer } from '../../store/reducers/user.reducer';
import { history } from '../../store/store';

const { changePassword } = userReducer.actions;

export const ChangePasswordPage = () => {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [success, setSuccess] = useState(false);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenParam = params.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    }
  }, []);

  const validateForm = () => {
    if (password.length < 8) {
      setPasswordError('Password must be at least 8 characters long');
      return false;
    }
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match');
      return false;
    }
    setPasswordError('');
    return true;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) return;
    dispatch(changePassword({ newPassword: password, token }));
    setSuccess(true);
  };

  return (
    <AuthLayout title="Change Password" subtitle="Please enter your new password." cardClassName="md:max-h-[90dvh]">
      {success ? (
        <>
          <AuthAlert type="success" message="Your password has been successfully changed." />
          <AuthButton onClick={() => history.push('/login')}>Sign In</AuthButton>
        </>
      ) : (
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {!token && <AuthInput label="Reset Token" value={token} onChange={setToken} name="token" />}

          <AuthInput
            label="New Password"
            type="password"
            value={password}
            onChange={setPassword}
            error={passwordError}
            helperText="Password must be at least 8 characters"
            autoComplete="new-password"
            name="password"
          />

          <AuthInput
            label="Confirm New Password"
            type="password"
            value={confirmPassword}
            onChange={setConfirmPassword}
            error={passwordError ? ' ' : undefined}
            autoComplete="new-password"
            name="confirmPassword"
          />

          <AuthButton type="submit">Change Password</AuthButton>
        </form>
      )}

      {!success && <AuthFooterLink text="" linkText="Back to login" to="/login" />}
    </AuthLayout>
  );
};
